/* Lirogo mobile Quick Add: Mango Original (1/2) y vista compartida (3).
   No clona formularios, no genera botones falsos y mantiene los eventos del tema. */
/*
   (function () {
  'use strict';
  var selector = 'collection-component.collection--mango-original';
  var pending = false;
  function sync() {
    pending = false;
    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll(selector).forEach(function (section) {
        section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
          var image = card.querySelector('.product-item__image');
          var qa = card.querySelector('quick-add-product.mango-original__quick-add');
          if (qa && image && qa.parentElement !== image) image.appendChild(qa);
          if (qa && section.classList.contains('mango-original--only-three')) {
            qa.classList.remove('mango-original__quick-add');
            var btn = qa.querySelector('.quick-add__button');
            if (btn && btn.dataset.lirogoAddedMini === 'true') {
              btn.classList.remove('quick-add__button--mini');
              delete btn.dataset.lirogoAddedMini;
            }
          }
        });
      });
      return;
    }
    document.querySelectorAll(selector).forEach(function (section) {
      var count = Number(section.dataset.lirogoMobileColumns || section.dataset.lirogoSelectedMobile || section.dataset.lirogoMobileDefault || 1);
      if ([1, 2, 3].indexOf(count) < 0) count = 1;
      if (section.classList.contains('mango-original--only-three')) {
        section.classList.toggle('collection--mango-mobile-style', count === 3);
      }
      if (section.classList.contains('mango-original--only-three') && count !== 3) {
        section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
          var image = card.querySelector('.product-item__image');
          var qa = card.querySelector('quick-add-product.mango-original__quick-add');
          if (qa && image && qa.parentElement !== image) image.appendChild(qa);
          if (qa) {
            qa.classList.remove('mango-original__quick-add');
            var btn = qa.querySelector('.quick-add__button');
            if (btn && btn.dataset.lirogoAddedMini === 'true') { btn.classList.remove('quick-add__button--mini'); delete btn.dataset.lirogoAddedMini; }
          }
        });
        return;
      }
      section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
        var image = card.querySelector('.product-item__image');
        var info = card.querySelector('.product-information');
        var qa = card.querySelector('quick-add-product.mango-original__quick-add') ||
          (image && image.querySelector('quick-add-product:not(.mango-original__quick-add)'));
        if (!qa || !image || !info) return;
        qa.classList.add('mango-original__quick-add');
        var holder = qa.querySelector('.quick-add__holder');
        if (!holder) return;
        if (section.classList.contains('mango-original--only-three')) {
          var button = qa.querySelector('.quick-add__button');
          if (button && !button.classList.contains('quick-add__button--mini')) {
            button.classList.add('quick-add__button--mini');
            button.dataset.lirogoAddedMini = 'true';
          }
          if (qa.parentElement !== image) image.appendChild(qa);
          return;
        }
        if (holder.classList.contains('desktop')) return;
        if (count === 1) {
          if (qa.parentElement !== card || qa.previousElementSibling !== info) info.insertAdjacentElement('afterend', qa);
        } else if (count === 2) {
          if (qa.parentElement !== info) info.appendChild(qa);
        } else if (qa.parentElement !== image) {
          image.appendChild(qa);
        }
      });
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lirogo-grid-device="mobile"][data-lirogo-grid-count]')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule);
  
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 &&
          (node.matches && (node.matches('[data-products-grid], .product-item, collection-component') ||
            node.querySelector && node.querySelector('[data-products-grid] .product-item')));
      });
    })) schedule();
  });
  function watch() {
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
*/

/* Lirogo mobile Quick Add: Mango Original (1/2) y vista compartida (3).
   No clona formularios, no genera botones falsos y mantiene los eventos del tema. */
/* Lirogo mobile Quick Add: Mango Original (1/2) y vista compartida (3).
   No clona formularios, no genera botones falsos y mantiene los eventos del tema. */
(function () {
  'use strict';
  var selector = 'collection-component.collection--mango-original';
  var pending = false;
  function sync() {
    pending = false;
    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll(selector).forEach(function (section) {
        section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
          var image = card.querySelector('.product-item__image');
          var qa = card.querySelector('quick-add-product.mango-original__quick-add');
          if (qa && image && qa.parentElement !== image) image.appendChild(qa);
          if (qa && section.classList.contains('mango-original--only-three')) {
            qa.classList.remove('mango-original__quick-add');
            var btn = qa.querySelector('.quick-add__button');
            if (btn && btn.dataset.lirogoAddedMini === 'true') {
              btn.classList.remove('quick-add__button--mini');
              delete btn.dataset.lirogoAddedMini;
            }
          }
        });
      });
      return;
    }
    document.querySelectorAll(selector).forEach(function (section) {
      var count = Number(section.dataset.lirogoMobileColumns || section.dataset.lirogoSelectedMobile || section.dataset.lirogoMobileDefault || 1);
      if ([1, 2, 3].indexOf(count) < 0) count = 1;
      if (section.classList.contains('mango-original--only-three')) {
        section.classList.toggle('collection--mango-mobile-style', section.dataset.lirogoQuickStyle === 'mango_style' || count === 3);
      }
      if (section.classList.contains('mango-original--only-three') && count !== 3) {
        section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
          var image = card.querySelector('.product-item__image');
          var qa = card.querySelector('quick-add-product.mango-original__quick-add');
          if (qa && image && qa.parentElement !== image) image.appendChild(qa);
          if (qa) {
            qa.classList.remove('mango-original__quick-add');
            var btn = qa.querySelector('.quick-add__button');
            if (section.dataset.lirogoQuickStyle === 'mango_style') {
              // Mango Style: reutilizar el mismo botón mini SOBRE la imagen en 1, 2 y 3.
              // Nunca moverlo al área de información ni quitarle su clase mini.
              if (btn) btn.classList.add('quick-add__button--mini');
            } else if (btn && btn.dataset.lirogoAddedMini === 'true') {
              // Button y Mini button: conservar su comportamiento previo en 1 y 2.
              btn.classList.remove('quick-add__button--mini');
              delete btn.dataset.lirogoAddedMini;
            }
          }
        });
        return;
      }
      section.querySelectorAll('[data-products-grid] .product-item').forEach(function (card) {
        var image = card.querySelector('.product-item__image');
        var info = card.querySelector('.product-information');
        var qa = card.querySelector('quick-add-product.mango-original__quick-add') ||
          (image && image.querySelector('quick-add-product:not(.mango-original__quick-add)'));
        if (!qa || !image || !info) return;
        qa.classList.add('mango-original__quick-add');
        var holder = qa.querySelector('.quick-add__holder');
        if (!holder) return;
        if (section.classList.contains('mango-original--only-three')) {
          var button = qa.querySelector('.quick-add__button');
          if (button && !button.classList.contains('quick-add__button--mini')) {
            button.classList.add('quick-add__button--mini');
            button.dataset.lirogoAddedMini = 'true';
          }
          if (qa.parentElement !== image) image.appendChild(qa);
          return;
        }
        if (holder.classList.contains('desktop')) return;
        if (count === 1) {
          if (qa.parentElement !== card || qa.previousElementSibling !== info) info.insertAdjacentElement('afterend', qa);
        } else if (count === 2) {
          if (qa.parentElement !== info) info.appendChild(qa);
        } else if (qa.parentElement !== image) {
          image.appendChild(qa);
        }
      });
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lirogo-grid-device="mobile"][data-lirogo-grid-count]')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule);
  /* AJAX filter/pagination replace product cards. Ignore movements of our own
     quick-add-product to avoid observer loops. */
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 &&
          (node.matches && (node.matches('[data-products-grid], .product-item, collection-component') ||
            node.querySelector && node.querySelector('[data-products-grid] .product-item')));
      });
    })) schedule();
  });
  function watch() {
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
